import { render } from "./materialdesign.vue?vue&type=template&id=5d449d47"
import script from "./materialdesign.vue?vue&type=script&lang=js"
export * from "./materialdesign.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gapp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__